<template>
    <div class="modules">
        <ModuleTeaser
            class="column is-2-desktop is-6-tablet is-6-mobile"
            :module="module"
            v-for="(module, index) in filteredAppModules"
            :key="index"
            :class="{ 'animate-shake': showShakeAnimation && module.id === promotedModule }"
            :id="`module-${module.id}`"
        />
    </div>
</template>

<script>
import ModuleTeaser from '@/components/ModuleTeaser.vue';
import { mapGetters } from 'vuex';
import { modulePropertiesMixin } from '@/mixins/moduleProperties.js';

export default {
    components: {
        ModuleTeaser,
    },
    mixins: [modulePropertiesMixin],
    data() {
        return {};
    },
    computed: {
        ...mapGetters({
            getAppModules: 'getAppModules',
            isPrefilled: 'isPrefilled',
            getAnimationState: 'getAnimationState',
            getFilledProductFieldCount: 'getFilledProductFieldCount',
            getProductFieldCount: 'getProductFieldCount',
            promotedModule: 'recommendation/getPromotedModule',
        }),
        showShakeAnimation() {
            return !this.$store.getters['clickBlocker'];
        },
        filteredAppModules() {
            return this.getAppModules.filter((module) => {
                if (
                    // max points of this module > 0
                    this.getProductFieldCount('appModules', module.id) > 0 ||
                    // filled points (so if prefilled) > 0
                    this.getFilledProductFieldCount('appModules', module.id).filled > 0
                ) {
                    return module;
                }
            });
        },
    },
};
</script>
